<template>
  <v-container fluid>
    <v-container fluid>
      <v-expansion-panels disabled flat style="border: 1px solid #0482fb">
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-header>
            Tri / Recherche ...
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Numéro dossier ..."
                  class="pt-5 pa-2 mx-2 ml-1"
                  v-model="sercheModel.fileNumber"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Emetteur ..."
                  class="pt-5 pa-2 mx-2"
                  v-model="sercheModel.transmitter"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  outlined
                  :items="userNameList"
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  v-model="sercheModel.agent"
                  flat
                  background-color="grey lighten-4"
                  label="Agent ... "
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="N° courrier arrivée"
                  class="pt-5 pa-2 mx-2"
                  v-model="sercheModel.mailNumber"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Debut date arrivée courrier début..."
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  type="date"
                  v-model="sercheModel.startDate"
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Debut date arrivée courrier fin..."
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  type="date"
                  v-model="sercheModel.endDate"
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Numéro courrier départ ..."
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  v-model="sercheModel.outgoingMailNumber"
                  flat
                  background-color="grey lighten-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  outlined
                  :items="items"
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  v-model="sercheModel.service"
                  flat
                  background-color="grey lighten-4"
                  label="Services ... "
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  outlined
                  :items="natureMails"
                  class="pt-5 pa-2 mx-2"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  v-model="sercheModel.nature"
                  flat
                  background-color="grey lighten-4"
                  label="Nature ... "
                ></v-select>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#0482fb"
                pill
                class="mr-2 white--text"
                @click="onEnter"
              >
                <v-icon left>
                  mdi-magnify
                </v-icon>
                Appliquer la recherche
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <template>
      <v-container>
        <v-dialog v-model="addFileMail" max-width="1000px">
          <v-card style="border-left: 10px solid #0482fb;">
            <!-- {{ victimModal.otherInfo.documentsProvides }} -->
            <v-card-title>
              <span class="text-h5 mb-5 mt-5" style="color:#0482fb;"
                >Suivi déclaration mobile</span
              >
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.receiptNumber"
                    label="Numéro quittance"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.sinisterAskNumber"
                    label="Numéro sinistre provisoire"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.name"
                    label="Nom raison sociale"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.phone"
                    label="Téléphone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    v-model="adnewObject.dateOfOccurrence"
                    color="#0482fb"
                    type="date"
                    label="Date de survenance"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    type="date"
                    v-model="adnewObject.declarationDate"
                    label="Date de déclaration"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.location"
                    label="Lieu sinistre"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.driverName"
                    label="Nom du conducteur"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.conductiveContact"
                    label="Contact conducteur"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.vehicleRegistration"
                    label="Immatriculation véhicule"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.thirdName"
                    label="Nom du tiers"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.thirdPartyMaterialDamage"
                    label="Dommages matériel tiers"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="adnewObject.thirdPartyBodilyInjury"
                    label="Dommage coporels tiers"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="12">
                  <v-textarea
                    outlined
                    v-model="adnewObject.circumstance"
                    rows="3"
                    color="#0482fb"
                    name="input-7-4"
                    label="Circonstance"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error darken-1"
                class="mr-5"
                @click="addFileMail = false"
                text
              >
                Fermer
              </v-btn>

              <v-btn color="success darken-1" @click="saveDeclaration()">
                Enregistrer le dossier
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addFileMailGed" max-width="900px">
          <v-card style="border-left: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h5 mb-5 mt-5" style="color:#0482fb;"
                >Gestionnaire de fichier</span
              >
              <v-spacer></v-spacer>
              <v-btn
                class="white--text ma-2"
                color="#0482fb"
                rounded
                @click="allDownload(filesListe)"
              >
                Tout télécharger
              </v-btn>
            </v-card-title>

            <v-item-group multiple>
              <v-container>
                <!-- {{filesListe}} -->
                <v-row>
                  <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                    <v-item>
                      <v-card
                        class="d-flex mb-100 align-center"
                        min-height="300"
                        min-width="100"
                      >
                        <v-img
                          :lazy-src="n.url"
                          class="align-self-stretch"
                          min-height="300"
                          min-width="100"
                          :src="n.url"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-fab-transition>
                          <v-btn
                            class="white--text ma-2"
                            color="#0482fb"
                            :href="n.url"
                            target="_blank"
                            dark
                            absolute
                            route
                            bottom
                            right
                            fab
                          >
                            <v-icon target="_blank" route :href="n.url"
                              >mdi-download</v-icon
                            >
                          </v-btn>
                        </v-fab-transition>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card>
        </v-dialog>
      </v-container>
    </template>
    <v-data-table
      class="pt-3"
      flat
      :loading="loading ? '#0482fb' : null"
      :headers="headers"
      :items="Mobile"
      :items-per-page="5"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <h4 class="text-h4 pageTitle ">
            Listing des déclarations sinistres mobiles
          </h4>

          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item="{ item }">
        <tr @click="handleClick(item)" class="green-bg">
          <!-- <td>
                <v-chip :color="getColor(item.status)" dark>
                  {{ item.status }}
                </v-chip>
              </td> -->
          <td>
            {{ item.actions }}
            <v-menu elevation="0" right offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                  <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-tooltip bottom color="warning">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon
                        size="20"
                        @click="handleClick(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="warning"
                        >mdi-file-edit-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Modifier le dossier</span>
                </v-tooltip>
                <v-tooltip bottom color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon
                        size="20"
                        @click="handleClickMailGed(item)"
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        >mdi-file-document-multiple-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Gestion des fichiers </span>
                </v-tooltip>

                <!-- <v-tooltip bottom color="grey darken-4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon
                            size="20"
                            color="grey darken-4"
                            v-bind="attrs"
                            v-on="on"
                            @click="medicalReport(item)"
                            >mdi-vector-link</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Rapport d'expertise médical</span>
                    </v-tooltip> -->
              </v-list>
            </v-menu>
          </td>
          <td>
            <v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </td>
          <td>{{ item.sinisterAskNumber }}</td>
          <td>{{ item.file.name }}</td>
          <td>{{ item.file.phone }}</td>
          <td>{{ item.file.nature }}</td>
          <td>{{ item.file.customerNumber }}</td>
          <td>{{ item.declarationDate }}</td>

          <td>{{ item.circumstance }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.thirdPartyMaterialDamage }}</td>
          <td>{{ item.thirdPartyBodilyInjury }}</td>
          <td>{{ item.thirdName }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { createDeclaration } from "@/api/user.js";
export default {
  name: "production",
  components: {},
  data: () => ({
    dialog: false,
    companyNameList: [],
    productNameList: [],
    sinisterDialog: false,
    dialogDelete: false,
    addFileMail: false,
    addFileMailGed: false,
    adnewObject: [],
    filesListe: [],
    sercheModel: {
      fileNumber: "",
      mailNumber: "",
      transmitter: "",
      switch1: true,
      agent: "",
      receptionStartDate: "",
      receptionEndDate: "",
      treatmentDate: "",
      assignmentDate: "",
      service: "",
    },
    fileName: "",
    product: "",

    sinisterAskNumber: "",
    sinisterCompanyNumber: "",
    startDate: "",
    endDate: "",
    company: "",
    loading: false,
    headers: [
      {
        text: "Actions",
        width: "50px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "Statut",
        width: "100px",
        align: "start",
        sortable: true,
        value: "status",
      },
      {
        text: "Numéro sinistre provisoire",
        width: "200px",
        align: "start",
        sortable: false,
        value: "sinisterAskNumber",
      },
      {
        text: "Nom raison sociale",
        width: "200px",
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: "Téléphone",
        width: "200px",
        align: "start",
        sortable: false,
        value: "phone",
      },
      {
        text: "Nature",
        width: "200px",
        value: "nature",
      },
      { text: "Numéro client", width: "200px", value: "dateOfOccurrence" },
      { text: "Date déclaration", width: "200px", value: "product" },
      { text: "Circonstance", width: "200px", value: "circumstance" },
      { text: "Lieu sinistre", width: "200px", value: "location" },
      {
        text: "Domage matériel",
        width: "200px",
        value: "thirdPartyMaterialDamage",
      },
      {
        text: "Domage corporel",
        width: "200px",
        value: "thirdPartyBodilyInjury",
      },
      { text: "Nom Tiers", width: "200px", value: "thirdName" },
      // { text: "Statut", value: "protein" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    declarationModal: {},
  }),

  computed: {
    ...mapGetters(["Mobile", "Companies", "Products"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getMobile",
      "getDeclarationSearch",
      "getProducts",
      "getCompanies",
    ]),
    showAllFillData() {
      this.initialize();
      //alert(this.showAllFil);
    },
    async makeSearchContract() {
      this.loading = true;
      //alert("ok");
      try {
        await this.getDeclarationSearch({
          fileName: this.fileName,
          product: this.product,
          sinisterAskNumber: this.sinisterAskNumber,
          sinisterCompanyNumber: this.sinisterCompanyNumber,
          startDate: this.startDate,
          endDate: this.endDate,
          company: this.company,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les sinistres")
        );
      }
      this.loading = false;
    },
    onEnter: function() {
      this.makeSearchContract();
    },
    allDownload(item) {
      for (let i = 0; i < item.length; i++) {
        window.open(item[i].url, "_blank");
      }
    },
    getColor(item) {
      if (item == "En cours") return "orange";
      else return "green";
    },
    async initialize() {
      this.loading = true;
      try {
        await this.getMobile({ withoutPeriod: this.showAllFil });
        await this.getCompanies();
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    editItem(item) {
      this.editedIndex = 1;
      this.declarationModal = Object.assign({}, item);
      this.sinisterDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.declarationModal = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },
    async handleClick(item) {
      this.adnewObject = Object.assign({}, item);
      this.adnewObject.name = item.file.name;
      this.adnewObject.phone = item.file.phone;

      this.addFileMail = true;
    },
    async handleClickMailGed(item) {
      this.filesListe = item.images;
      this.addFileMailGed = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          circumstance: this.adnewObject.circumstance,
          dateOfOccurrence: this.adnewObject.dateOfOccurrence,
          declarationDate: this.adnewObject.declarationDate,
          // location: this.adnewObject.location,
          driverName: this.adnewObject.driverName,
          conductiveContact: this.adnewObject.conductiveContact,
          // vehicleRegistration: this.adnewObject.vehicleRegistration,
          materialDamageInsured: this.adnewObject.thirdPartyMaterialDamage,
          insuredBodilyInjury: this.adnewObject.thirdPartyBodilyInjury,
          disasterObject: this.adnewObject.thirdPartyMaterialDamage,
          // file: this.File._id,
        };

        if (this.adnewObject.dateOfOccurrence != "") {
          // add
          await createDeclaration({
            schema,
            id: "",
            receiptNumber: this.adnewObject.receiptNumber,
            mobileID: this.adnewObject._id,
          });
          // await updateMobileDeclaration({ id: this.adnewObject._id, Make });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Declaration")
          );
          this.closeDeclaration();
          this.initialize();
        } else {
          defaultMethods.dispatchError("Date survenance requis");
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.adnewObject = {};
      this.addFileMail = false;
      // this.currentProduct = null;
    },
  },
};
</script>

<style scoped>
.btnDesign {
  color: #fff;
}

.space {
  margin-left: -100px;
  margin-right: -100px;
}
.pageTitle {
  font-size: 10px;
  font-weight: bold;
  color: #0482fb;
}

.green-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
}
td {
  font-size: 12px !important;
  border-bottom: 1px solid #f4f7fe !important;
}
.green-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: #0482fb !important;
  color: white;
  height: 70px;
  animation: -45deg;
  cursor: pointer;
  box-shadow: inset 0 0 1em #0482fb, 0 0 2em #eeeeee;
}
</style>
